import React from 'react';
import './profile.css';
import profilepic from '../../assets/images/profilepic.jpeg';

const Profile = () => {
	return (
		<div>
			<table>
				<caption>
					<h1>Profile</h1>
					<img className="profilepic" src={profilepic} height={200} />
				</caption>
				<tr>
					<th>Name</th>
					<td>Pekka Peloton</td>
				</tr>

				<tr>
					<th>Phone</th>
					<td>050-1234567</td>
				</tr>

				<tr>
					<th>Email</th>
					<td>pekka@peloton.fi</td>
				</tr>

				<tr>
					<th>How do you feel about going to the dentist?</th>
					<td>
						Going to the dentist is hard and difficult. I am a
						little bit scared if I have cavities.{' '}
					</td>
				</tr>

				<tr>
					<th>Previous procedures</th>
					<td>
						In general, my teeth have been in good shape. <br />
						2015: Regular checkup, removed calculus. <br />
						2013: Regular checkup. No cavities.{' '}
					</td>
				</tr>
			</table>
		</div>
	);
};

export default Profile;



// WEBPACK FOOTER //
// ./src/components/Profile/index.js